import { render, staticRenderFns } from "./CRMButtons.vue?vue&type=template&id=cab1703a&"
import script from "./CRMButtons.vue?vue&type=script&lang=js&"
export * from "./CRMButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports